import { render, staticRenderFns } from "./checkoutPage.vue?vue&type=template&id=7b22d9d4&scoped=true"
import script from "./checkoutPage.vue?vue&type=script&lang=js"
export * from "./checkoutPage.vue?vue&type=script&lang=js"
import style0 from "./checkoutPage.vue?vue&type=style&index=0&id=7b22d9d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b22d9d4",
  null
  
)

export default component.exports